<template>
<div class="chapter">
<div class="inner_page">
<p class="line" id="blueline1"><img alt="image" src="Images/blueline.jpg"/></p>
<p class="tx">Well-intentioned people of pallor went seamlessly from not seeing color to being allies. Being part of the problem was never considered. And, really, “ally” was fine for a while. It was aspirational. But now “I’m an ally” is the “Don’t hurt me!” of our time. Don’t nobody want you, Karen. You can keep that to yourself.</p>
<p class="line" id="blueline2"><img alt="image" src="Images/blueline.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chap2.vue?137c500d